import { IApplicationData } from '../interfaces';
import { eApplicationActions, IApplicationActions } from '../actions';
import { createPartyPerson } from '../../../ui-toolkit/orders/interfaces/IPartyPerson';

export const presentOrderReducer = (oldState: IApplicationData, action: IApplicationActions): IApplicationData => {
  switch (action.type) {
    case eApplicationActions.CreateOrderLinkRequest:
      return {
        ...oldState,
        orderLinkRequestData: action.payload,
      };
    case eApplicationActions.ReplaceOrderLinkRequest:
      return { ...oldState, orderLinkRequestData: action.payload };
    case eApplicationActions.DeleteOrderLinkRequest:
      return { ...oldState, orderLinkRequestData: null };
    case eApplicationActions.StartPartyEdit:
      return {
        ...oldState,
        partyModals: {
          ...oldState.partyModals,
          editingParty: action.payload,
          addingParty: undefined,
          deletingParty: undefined,
        },
      };
    case eApplicationActions.StartPartyDelete:
      return {
        ...oldState,
        partyModals: {
          ...oldState.partyModals,
          deletingParty: action.payload,
          editingParty: undefined,
          addingParty: undefined,
        },
      };
    case eApplicationActions.ChangePartyModalMessage:
      return { ...oldState, partyModals: { ...oldState.partyModals, modalMessage: action.payload } };
    case eApplicationActions.ClearPartyModalMessage:
      return { ...oldState, partyModals: { ...oldState.partyModals, modalMessage: undefined } };
    case eApplicationActions.FinishPartyChanges:
      return {
        ...oldState,
        partyModals: {
          ...oldState.partyModals,
          addingParty: undefined,
          editingParty: undefined,
          deletingParty: undefined,
        },
      };
    case eApplicationActions.StartPartyCreate:
      return {
        ...oldState,
        partyModals: {
          ...oldState.partyModals,
          addingParty: createPartyPerson({ purpose: action.payload, first_name: '', last_name: '' }),
          editingParty: undefined,
        },
      };
    case eApplicationActions.ChangeValues:
      return { ...oldState, ...action.payload };
    case eApplicationActions.SetLenderUserList:
      return { ...oldState, lenderUsers: action.payload };
    case eApplicationActions.StartPartyInviting:
      return {
        ...oldState,
        partyModals: {
          ...oldState.partyModals,
        },
      };
  }
};
